import React from 'react';
import {apiService} from '../../common/apiCallService';
import Loading from '../Loading.js';
import {baseUrl} from '../../common/config.js';
import Paper from 'material-ui/Paper';
import MediaQuery from 'react-responsive';
import PokerwatchTable from './PokerwatchTable.js'
import PokerwatchFilters from './PokerwatchFilter.js'
import moment from 'moment';
import { Redirect } from 'react-router';
import 'moment-timezone';
import {getFormattedDate, getFormattedTime} from '../../common/commonService.js'
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../../common/commonService'
var _ = require('lodash');
import Menu from '../Menu'

class PokerWatch extends React.Component {
    constructor(props, context) {
        super(props, context);
        const filters = sessionStorage.getItem('PokerWatchFilters') ? 
            JSON.parse(sessionStorage.getItem('PokerWatchFilters')) : 
            {};
        this.state = {
            overALlSummery: [],
            playerSummary: [],
            searchPlayerSummary: [],
            loading: true,
            totalCount: 0,
            sortColumn:'Profit/Loss',
            shiftValue:'Select',
            timeValue:'Select',
            timeZonevalue:'Select',
            alias:'',
            timeZone:moment.tz.guess(),
            loginRedirect: false,
            nightShift:false,
            shift:"Select",
            title: 'Poker Watch',
            businessList: [],
            selectedBuss: '',
            playersList: [],
            selectedPlayer: '',
            coachList: [],
            selectedCoach: '',
            coachIds:[],
            businessIds:[],
            isCoach:0,
            searchTime:{
                reqFromDate: '',
                reqToDate: '',
                reqFromTime: '',
                reqToTime: '',
                shift:"Select",
            },
            showFilter:false,
            label:'Open',
            arrow:'fa fa-chevron-down',
            btnColor:'#DE460F',
            shift:"Select",
            access: JSON.parse(localStorage.getItem('userRole')),
            fTime:moment().format("HH:mm:ss"),
            tTime:moment().format("HH:mm:ss"), 
            timeZoneOffset: new Date().getTimezoneOffset(),
            zoneDiff: moment().tz('Europe/London').format('Z').split(':')[0],  
            toTimeZoneDate:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            todaysDate:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            toDate:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            fromDate :moment(new Date()).subtract(1,'days').format("YYYY-MM-DD HH:mm:ss"),
            ...filters
        }

        if(this.state.access.indexOf('SYS_ADMIN') !=-1 || this.state.access.indexOf('SHIFT_MANAGER') !=-1 || this.state.access.indexOf('BUSINESS_OWNER') !=-1 || this.state.access.indexOf('PLAYER') !=-1 ){
            this.state.isCoach=0
            this.getBusinessList(() => this.setState({...filters}));
        }
        else{
            this.state.isCoach=1
            this.getPlysAndCoach({isCoach: this.state.isCoach}, () => this.setState({...filters}))
        }

    }

    componentDidMount() {
        createVirtualPageLoad("/pokerWatch")
        document.title = "Poker Watch";
    }   
    
    componentWillUnmount() {
        closeVirtualPage()
        document.title = "My Game";
        this.saveFiltersToLocalStorage();
    }    
    
    handleTimeZone = (event,index,value) => {
        this.setState({
          timeValue:"Select",
          shiftValue:"Select",
          timeZonevalue:value
        });
        this.state.timeZone=value
        this.state.searchTime.shift="Select"
    }

    getOverAllSummary = () =>{
        let selectedPlayer = []
        this.state.playersList.map((ply) => {
            if (this.state.selectedPlayer.indexOf(ply.alias) != -1)
                selectedPlayer.push(ply.accountName)
        })
        this.setState({loading: true})
        if((this.state.selectedPlayer).length>0){
            apiService(baseUrl + '/pokerWatch/overAllSummary', {
                "fromDate": this.state.searchTime.reqFromDate,
                "toDate": this.state.searchTime.reqToDate,
                "fromTime":this.state.searchTime.reqFromTime,
                "toTime":this.state.searchTime.reqToTime,
                "shift":this.state.searchTime.shift,
                "selectedPlrList":selectedPlayer,
                'gameType':'cash',
                'userRole':localStorage.getItem("userRole")
            }, (data) => {
                this.setState({overALlSummery: data})
                this.getplayerSummary()
            }, (data) => {
                if(data.status == 403)
                this.setState({loginRedirect: true})
            })
        }
        else {
          this.setState({playerSummary: []})
          this.setState({totalCount:0})
          this.setState({searchPlayerSummary: []})
          this.setState({overALlSummery:[]})
          this.setState({loading: false})
        }
    }

    getplayerSummary = (sortBy= 'asc',currColumn='profit',max=10,offset=0) => {
        let selectedPlayer = []
        this.state.playersList.map((ply) => {
            if (this.state.selectedPlayer.indexOf(ply.alias) != -1)
                selectedPlayer.push(ply.accountName)
        })
        this.setState({loading: true})
        if((this.state.selectedPlayer).length>0){
            apiService(baseUrl + '/pokerWatch/playerSummary', {
                "fromDate": this.state.searchTime.reqFromDate,
                "toDate": this.state.searchTime.reqToDate,
                "fromTime":this.state.searchTime.reqFromTime,
                "toTime":this.state.searchTime.reqToTime,
                "max": max,
                "offset": offset,
                "sortBy": sortBy,
                "column": currColumn,
                "shift":this.state.searchTime.shift,
                'gameType':'cash',
                "selectedPlrList":selectedPlayer,
                'userRole':localStorage.getItem("userRole")    
            }, (data) => {
              
                this.setState({searchPlayerSummary: data.list})
                this.setState({playerSummary: data.list})
                this.setState({totalCount: this.state.overALlSummery.totalPlayers})
                this.setState({loading: false})
            }, (data) => {
                this.setState({loading: false})
                if(data.status == 403)
                    this.setState({loginRedirect: true})
            })

        }
        else {
          this.setState({playerSummary: []})
          this.setState({totalCount:0})
          this.setState({searchPlayerSummary: []})
          this.setState({overALlSummery:[]})
          this.setState({loading: false})
        }
    }

    setShiftTimeOnZone = (fromDate, toDate, fTime, tTime, shift) => {
        if(fTime && tTime) {
            var fromDate = new Date(fromDate.replace(/-/g, '/'))
            var toDate = new Date(toDate.replace(/-/g, '/'))
            var shftFromDt = fTime.split(':')
            var shftToDt = tTime.split(':')
            if(this.state.zoneDiff > 0) {
              fromDate.setHours(shftFromDt[0] - Math.abs(this.state.zoneDiff))
              toDate.setHours(shftToDt[0] - Math.abs(this.state.zoneDiff))
            } else if(this.state.zoneDiff < 0){
              fromDate.setHours(shftFromDt[0] + Math.abs(this.state.zoneDiff))
              toDate.setHours(shftToDt[0] + Math.abs(this.state.zoneDiff))
            }
            fromDate.setMinutes(0)
            fromDate.setSeconds(0)
            toDate.setMinutes(0)
            toDate.setSeconds(0)
            this.state.searchTime.shift = shift
            this.state.searchTime.reqFromTime = getFormattedTime(fromDate)
            this.state.searchTime.reqToTime = getFormattedTime(toDate)
            this.state.searchTime.reqFromDate = getFormattedDate(fromDate)
            this.state.searchTime.reqToDate = getFormattedDate(toDate)
            this.forceUpdate()
            this.getOverAllSummary()
        }
    }

    callApi = (fromDate=this.state.fromDate,toDate=this.state.toDate,fTime=this.state.fTime,tTime=this.state.tTime,shift=this.state.shift,selectedPlayer=this.state.selectedPlayer) => {
        this.state.selectedPlayer = selectedPlayer
        this.setState({
            fromDate,
            toDate,
            fTime,
            tTime,
            shift,
            selectedPlayer
        });
        this.setState({loading: false})
        if(shift == 'NightShift' || shift == 'DayShift' || shift == 'MorningShift') {
          this.setShiftTimeOnZone(fromDate, toDate, fTime, tTime, shift)
        }
        else {
            fromDate = new Date(fromDate.replace(/-/g, '/'))
            toDate = new Date(toDate.replace(/-/g, '/'))
            if(this.state.timeZoneOffset > 0) {
                fromDate = new Date(fromDate.getTime() + this.state.timeZoneOffset * 60000);
                toDate = new Date(toDate.getTime() + this.state.timeZoneOffset * 60000);
                this.state.searchTime.reqFromDate = getFormattedDate(fromDate)
                this.state.searchTime.reqToDate = getFormattedDate(toDate)
            }else if(this.state.timeZoneOffset < 0) {
                fromDate = new Date(fromDate - Math.abs(this.state.timeZoneOffset) * 60000);
                toDate = new Date(toDate - Math.abs(this.state.timeZoneOffset) * 60000);
                this.state.searchTime.reqFromDate = getFormattedDate(fromDate)
                this.state.searchTime.reqToDate = getFormattedDate(toDate)
            }else {
                this.state.searchTime.reqFromDate = this.state.fromDate
                this.state.searchTime.reqToDate = this.state.toDate
            }
            this.state.searchTime.reqFromTime = getFormattedTime(fromDate)
            this.state.searchTime.reqToTime = getFormattedTime(toDate)
            this.forceUpdate()
            this.getOverAllSummary()
        }
    }

    saveFiltersToLocalStorage = () => {
        const {
            fromDate,
            toDate,
            fTime,
            tTime,
            shift,
            selectedPlayer
        } = this.state;
        sessionStorage.setItem(
            'PokerWatchFilters', 
            JSON.stringify({
                fromDate,
                toDate,
                fTime,
                tTime,
                shift,
                selectedPlayer
            })
        );
    }
    sortingForMob(event) {
        this.setState({value:event.target.value});
        this.state.sortColumn=event.target.value
        if(this.state.sortColumn=='players.alias')  this.setState({sortColumn:'Trader Name'})
        else if(this.state.sortColumn=='games')  this.setState({sortColumn:'Game'})
        else if(this.state.sortColumn=='player_rake')  this.setState({sortColumn:'Rake'})
        else  this.setState({sortColumn:'Profit/Loss'})
        var value = event.target.value;
        if(value!=null){
            if(value==0){
                this.state.msg="please select proper sort"
                this.handleOpen();
            }else {
                if(value=="players.alias" || value=="player_rake" || value=="games" || value=="profit"){
                  this.setState({value:'0'});
                  this.sorting(value)
                }
            }
        }
    }

     handleOpen () {
       this.setState({loading: false})
       this.setState({open: true});
     };

     handleClose () {
       this.setState({open: false});
     };

     onTimerCancel(index){
       if(index==1){
           this.state.fromDate=this.state.fromDate+' '+"00:00:00"
           this.state.fromTimeZoneDate=this.state.fromDate
       }
       else {
           this.state.toDate=this.state.toDate+' '+"00:00:00"
           this.state.toTimeZoneDate=this.state.toDate
       }
       this.forceUpdate()
     }

    getBusinessList = (callback = () => {}) => {
        this.setState({loading: true})
        apiService(baseUrl + '/appUser/getRolesByAccess', {
            userRole: localStorage.getItem('userRole')
        }, (data) => {
            this.setState({loading: true})
            this.setState({businessList: data.buss})
            var list = []
            list = this.state.businessList.map(function(id) {return id._id})
            this.setState({selectedBuss: list})
            this.getPlysAndCoach({businessIds: this.state.selectedBuss},callback)
        }, (data) => {
            this.setState({loading: false})
            if(data.status == 403){
                this.setState({loginRedirect: true})
            }
        })
    }

    getPlysAndCoach = (query, callback = () => {}) => {
        this.setState({selectedPlayer:[]})
        this.setState({loading: true})
        apiService(baseUrl + '/appUser/getPlysAndCoach', query, (data) => {
            let sortedPlayer = _.orderBy( data.players, [player => player.alias && player.alias.toLowerCase()], ['asc']);
            this.setState({playersList: sortedPlayer})
            this.setState({playerAlias: sortedPlayer})
            this.setState({searchplayerAlias: sortedPlayer})
            if(data.coaches.length>0){
              this.setState({coachList: data.coaches})
            }
            var list = []
            list = this.state.playersList.map(function(id) {return id.alias})
          
            this.setState({selectedPlayer: list, loading: false}, callback)
            this.callApi(this.state.fromDate,this.state.toDate,this.state.fTime,this.state.tTime,this.state.shift,list)
        }, (data) => {
            this.setState({loading: false})
            if(data.status == 403) {
               localStorage.setItem("pathName", this.props.pathname)
               this.setState({loginRedirect: true})
            }
        })
    }

    onBussChange = (event, index, value) => {
        this.setState({coachList: [], playersList: [], selectedCoach: '', selectedPlayer: ''})
        if(value.indexOf('All') !== -1) {
            var list = []
            if ((value.length - 1) === this.state.businessList.length) list=[]
            else list = this.state.businessList.map(function(id) {return id._id})
            this.setState({selectedBuss: list})
            if(list.length > 0) this.getPlysAndCoach({businessIds: list})
        } else{
            this.setState({selectedBuss: value})
            if(value.length > 0) this.getPlysAndCoach({businessIds: value})
        }
    }
 
    onCoachChange = (event, index, value) => {
        this.state.selectedCoach = ''
        if(value.indexOf('All') !== -1) {
          var list = []
          if ((value.length - 1) === this.state.coachList.length) list=[]
          else list = this.state.coachList.map(function(id) {return id._id})
          this.setState({selectedCoach: list})
          if(list.length > 0) this.getPlysAndCoach({coachIds: list})
          else this.getPlysAndCoach({businessIds: this.state.selectedBuss})
        } else {
          this.setState({selectedCoach: value})
          if(value.length > 0) this.getPlysAndCoach({coachIds: value})
          else this.getPlysAndCoach({businessIds: this.state.selectedBuss})
        }
    }
      
    showFilter = () => {
        if(this.state.showFilter){
         if(this.state.label=='Open')
           this.setState({label: 'Close'})
         else
           this.setState({label: 'Open'})
         this.setState({showFilter: false})
         this.setState({arrow: 'fa fa-chevron-down'})
         this.setState({btnColor: '#DE460F'})
        }
        else{
         if(this.state.label=='Open')
           this.setState({label: 'Close'})
         else
           this.setState({label: 'Open'})
         this.setState({showFilter: true})
         this.setState({arrow: 'fa fa-chevron-up'})
         this.setState({btnColor: '#1F1E23'})
        }
    }

    render(){
        this.props.setHeaderTitle(this.state.title)
        return(
            <div>
               {this.state.loginRedirect && (<Redirect to={'/'}/>)}
               {this.state.loading  ? <Loading/>: null}
               <div className="container">
                <Paper zDepth={1} rounded={false} className="resp-paper" style={{backgroundColor: '#2D2C34'}}>
                    <div className="row">
                        <div className="col-sm-4" data-e2e="Games">
                            <b>Games:</b>{this.state.overALlSummery.totalGames}({this.state.overALlSummery.totalPlayers}
                                Players)
                        </div>
                        <div className="col-sm-4" data-e2e="Rake">
                            <b>Rake:</b>{this.state.overALlSummery.totalRake}
                        </div>
                        <div className="col-sm-4" data-e2e="Profit/Loss">
                            <b>Profit/Loss:</b>{this.state.overALlSummery.totalProfit}
                        </div>
                    </div>
                    <br/>
                   
                        <MediaQuery maxWidth={760}>
                            {(matches) => {
                            if (matches) {
                                return(
                                    <div style={{marginTop:'2%'}} className="mobileFilter">
                                        <center>
                                            <button  onTouchTap={() =>  this.showFilter()}  style={{backgroundColor:this.state.btnColor,display:'block',width:'100%', border:"2px solid #DE460F",whiteSpace: 'normal',color: 'white',paddingTop:'2%',paddingBottom:'2%'}}>
                                                {this.state.label} pokerwatch filters <i className={this.state.arrow} aria-hidden="true" style={{color:'white'}}></i>
                                            </button>
                                        </center>
                                        {this.state.showFilter
                                            ?
                                            <div className='backColor' style={{marginTop:'0',paddingLeft:'10px'}}>
                                            <PokerwatchFilters 
                                                fromDate={this.state.fromDate}
                                                toDate={this.state.toDate}
                                                shiftValue={this.state.shiftValue}
                                                timeValue={this.state.timeValue}
                                                selectedPlayer={this.state.selectedPlayer}
                                                businessList={this.state.businessList}
                                                selectedBuss={this.state.selectedBuss} 
                                                onBussChange={this.onBussChange}
                                                coachList={this.state.coachList}
                                                selectedCoach={this.state.selectedCoach}
                                                onCoachChange={this.onCoachChange}
                                                playersList={this.state.playersList}
                                                pathname={this.props.location.pathname}
                                                callApi={this.callApi}
                                            />
                                            </div>
                                            :null
                                        }
                                    </div>
                                )
                            }
                            else{
                                return(
                                    <PokerwatchFilters 
                                        fromDate={this.state.fromDate}
                                        toDate={this.state.toDate}
                                        shiftValue={this.state.shiftValue}
                                        timeValue={this.state.timeValue}
                                        selectedPlayer={this.state.selectedPlayer}
                                        selectedBuss={this.state.selectedBuss}
                                        businessList={this.state.businessList}
                                        onBussChange={this.onBussChange} 
                                        onBussChange={this.onBussChange}
                                        coachList={this.state.coachList}
                                        selectedCoach={this.state.selectedCoach}
                                        onCoachChange={this.onCoachChange}
                                        showFilter={this.state.showFilter} 
                                        playersList={this.state.playersList}
                                        pathname={this.props.location.pathname}
                                        callApi={this.callApi}
                                        />    
                                )
                            }
                            }}
                        </MediaQuery>
                     
                    {this.state.totalCount==0 
                        ?
                        <div data-e2e="noData">
                            <br/><br/>
                            <h5><center>No Data Available For Given Search Date</center></h5>
                        </div>
                        :  
                        <PokerwatchTable onRedirect={this.saveFiltersToLocalStorage} totalCount={this.state.totalCount} searchPlayerSummary={this.state.searchPlayerSummary} searchTime={this.state.searchTime} getplayerSummary={this.getplayerSummary}/>
                
                        }
                </Paper>
                </div>
            </div>
        )
    }

}


const mapDispatchToProps = dispatch => {
    return {
      setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
    }
  };
  
export default connect( null, mapDispatchToProps )( PokerWatch );



/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchComp/Pokerwatch.js
 **/